import { useFullScreenLoader } from '@/hooks/use-full-screen-loader';

/** Standalone markup also supports Storybook and embeds without the app host. */
export const FullScreenBrandLoader = () => {
  const hasPersistentHost = useFullScreenLoader();
  if (hasPersistentHost) {
    return null;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface">
      <output aria-label="Loading" className="block w-65 max-w-[calc(100vw-64px)]">
        <img
          alt=""
          aria-hidden="true"
          className="block h-auto w-full [color-scheme:light] motion-reduce:hidden dark:[color-scheme:dark]"
          height={241}
          src="/svg/wordmark-loader.svg"
          width={1058}
        />
        <span
          aria-hidden="true"
          className="hidden aspect-[1058/241] w-full bg-[var(--color-brand-logo-fg)] motion-reduce:block"
          style={{
            mask: 'url(/svg/logo-wordmark.svg) center / contain no-repeat',
            WebkitMask: 'url(/svg/logo-wordmark.svg) center / contain no-repeat',
          }}
        />
      </output>
    </div>
  );
};
